'use client';

import { logInAction } from '@veranda/shared/authentication/actions';
import { NavbarButton } from '@veranda/shared/layout/navbar';
import { useTransition } from 'react';

export function AccountButton() {
  const [_, startTransition] = useTransition();

  return (
    <NavbarButton
      icon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 24 24"
          id="account-button-icon"
          className="size-6 text-primary"
        >
          <title>Account</title>
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 4a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM6.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM12 17c-3.191 0-6.107 1.389-8.272 3.686a1 1 0 0 1-1.456-1.372C4.778 16.656 8.205 15 12 15s7.222 1.656 9.728 4.314a1 1 0 0 1-1.456 1.372C18.107 18.389 15.192 17 12 17Z"
            clipRule="evenodd"
          />
        </svg>
      }
      onClick={() => {
        startTransition(async () => {
          await logInAction();
        });
      }}
      ariaLabel="Go to account"
    />
  );
}
